<template>
  <div>
    <div class="px-3 py-2">
      <b-row class="align-items-center">
        <b-col sm="8">
          <b-button size="sm"
                    :variant="addFilter ? 'dark' : 'outline-dark'"
                    @click="addFilter = !addFilter">
            Add Filter
          </b-button>
        </b-col>
        <b-col sm="4">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="icon-magnifier"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text"
                          class="form-control"
                          placeholder="Search by email"
                          autocomplete="off"
                          v-model="serverParams.keyword"
                          @input="onChange" />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div v-show="addFilter" class="px-3 p-2 border-top">
      <b-row>
        <b-col sm="4">
          <b-form-input type="text"
                        placeholder="Name"
                        autocomplete="off"
                        v-model="serverParams.fullName"
                        @input="onChange" />
        </b-col>
        <b-col sm="4">
          <treeselect :options="options.role"
                      placeholder="Select Role"
                      v-model="serverParams.role"
                      @input="onChange" />
        </b-col>
        <b-col sm="4">
          <treeselect :options="options.status"
                      placeholder="Select Status"
                      v-model="serverParams.actived"
                      @input="onChange" />
        </b-col>
        <b-col sm="4" class="mt-2">
          <BuildingDropdown :server-params="serverParams"
                            :on-select="onChange" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { role, status } from "@/shared/options";
  import BuildingDropdown from "@/components/common/BuildingDropdown";

  export default {
    props: {
      serverParams: Object,
    },
    data: () => ({
      addFilter: false,
      options: {
        role,
        status,
      },
    }),
    components: {
      BuildingDropdown,
    },
    methods: {
      onChange() {
        this.serverParams.pageNumber = 1;
        this.$emit("onChange", this.serverParams);
      },
    },
  };
</script>
